module.exports = __webpack_public_path__ + "static/media/pix-logo.7fc6a8ed.svg";